import { render, staticRenderFns } from "./MajorList.vue?vue&type=template&id=6bf86cba&scoped=true"
import script from "./MajorList.vue?vue&type=script&lang=js"
export * from "./MajorList.vue?vue&type=script&lang=js"
import style0 from "./MajorList.vue?vue&type=style&index=0&id=6bf86cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf86cba",
  null
  
)

export default component.exports